import { render, staticRenderFns } from "./TalentsListFilter.vue?vue&type=template&id=a48d91ac&scoped=true"
import script from "./TalentsListFilter.vue?vue&type=script&lang=js"
export * from "./TalentsListFilter.vue?vue&type=script&lang=js"
import style0 from "./TalentsListFilter.vue?vue&type=style&index=0&id=a48d91ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48d91ac",
  null
  
)

export default component.exports